import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/es';

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

export type { Dayjs } from 'dayjs';
export default dayjs;
